import * as React from 'react';

export interface IMapErrorBoundaryProps {
  children: React.ReactNode;
  onError(error: Error): void;
}

interface IMapErrorBoundaryState {
  hasError: boolean;
}

export class MapErrorBoundary extends React.Component<IMapErrorBoundaryProps, IMapErrorBoundaryState> {
  public state: IMapErrorBoundaryState = { hasError: false };

  public static getDerivedStateFromError(): IMapErrorBoundaryState {
    return { hasError: true };
  }

  public componentDidCatch(error: Error): void {
    this.props.onError(error);
  }

  public render(): React.ReactNode {
    if (this.state.hasError) {
      return null;
    }

    return this.props.children;
  }
}
